<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
    <div v-if="client" class="flex flex-col gap-4 text-secondary">
        <!-- TABS -->
        <div class="tabs tabs-boxed">
            <a
                v-for="(tab, index) of tabs"
                v-bind:key="index"
                class="tab text-secondary"
                :class="{ 'tab-active text-primary': tab.id === currentTab }"
                @click="currentTab = tab.id"
                >{{ tab.name }}</a
            >
        </div>

        <general-tab v-show="currentTab === 'general'" :mode="mode" v-model="client" @save="save"></general-tab>
        <scopes-tab v-show="currentTab === 'scopes'" :mode="mode" v-model="client" @save="save"></scopes-tab>
        <claims-tab v-show="currentTab === 'claims'" :mode="mode" v-model="client" @save="save"></claims-tab>
        <api-keys-table
            v-show="currentTab === 'api-keys' && mode === 'update'"
            :subject="client.client_id"
            type="application"
        ></api-keys-table>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useClientsStore } from '@/stores/clients';
import { useApplicationStore } from '@/stores/application';
import GeneralTab from '@/components/clients/tabs/GeneralTab';
import ScopesTab from '@/components/clients/tabs/ScopesTab';
import ClaimsTab from '@/components/clients/tabs/ClaimsTab';
import ApiKeysTable from '@/components/api-key/ApiKeysTable.vue';

export default {
    name: 'UpsertClientComponent',
    props: ['modelValue', 'mode'],
    components: { ApiKeysTable, ClaimsTab, ScopesTab, GeneralTab },
    data() {
        return {
            client: undefined,
            currentTab: 'general',
            tabs: [
                {
                    name: 'Allgemein',
                    id: 'general',
                    icon: 'fa-regular fa-gears'
                },
                {
                    name: 'Scopes',
                    id: 'scopes',
                    icon: 'fa-regular fa-cubes'
                },
                {
                    name: 'Claims',
                    id: 'claims',
                    icon: 'fa-regular fa-cube'
                },
                {
                    name: 'Api Keys',
                    id: 'api-keys',
                    icon: 'fa-regular fa-key'
                }
            ]
        };
    },
    computed: {
        ...mapStores(useClientsStore, useApplicationStore)
    },
    created() {
        this.client = this.modelValue;
    },
    methods: {
        save() {
            this.$emit('save', this.client);
        },
        isMode(mode) {
            return this.mode === mode;
        }
    }
};
</script>

<style scoped>
.tabs-boxed .tab-active {
    color: var(--venus-color-primary) !important;
}
</style>
